export default {
  version: '1.1.1', // 后台版本
}
